// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"rY-z","subtitle":"sY-z","wrapper":"tY-z","leftArrow":"uY-z","rightArrow":"vY-z"};